import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Influencer from "./Influencer";
import type Outlet from "./Outlet";

@Model()
class InfluencerOutlet extends ApplicationRecord {
  static jsonapiType = "influencers_outlets";

  @Attr() archivedAt: string;

  @BelongsTo() influencer: Influencer;

  @Attr() influencerId: string;

  @BelongsTo() outlet: Outlet;

  @Attr() outletId: string;
}

export default InfluencerOutlet;
